<template>
  <div class="card-detalhes-pedido-andamento">
    <g-card class="card-consultas-carta-header" :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
          />
          <div class="titulo-detalhes-cabecalho"> Detalhes </div>
        </div>

        <div class="header-icons" v-tooltip="'Abrir PDF'">
          <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            @click="imprimir()"
          />
        </div>
      </div>

      <div class="conteudo-card-detalhes-pedido-cancelado espacamento-detalhes">
        <div class="container-detalhes-pedido">
          <div class="dados-produto-titulo titulo-grupo-detalhes "> Detalhes do Pedido </div>

          <div class="grupo-dados-produto">
            <div class="dados-pedido-pedido">
              <div class="titulo-conteudo-detalhes"> Pedido </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.CodigoExternoPedido}} </div>
            </div>

            <div class="dados-pedido-orcamento">
              <div class="titulo-conteudo-detalhes"> Orcamento </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
            </div>

            <div class="dados-pedido-tipo">
              <div class="titulo-conteudo-detalhes"> Tipo </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
            </div>

            <div class="dados-pedido-cliente">
              <div class="titulo-conteudo-detalhes"> Cliente / CNPJ </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.CodigoExternoCliente}} - {{detalhesDoPedidoFluxo.NomeFantasia}} / {{detalhesDoPedidoFluxo.CnpjFormatado }} </div>
            </div>

            <div class="dados-pedido-representante">
              <div class="titulo-conteudo-detalhes"> Representante </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.NomeRepresentante}} </div>
            </div>

            <div class="dados-pedido-unidade">
              <div class="titulo-conteudo-detalhes"> Unidade </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.NomeEmpresa}} </div>
            </div>

            <div class="dados-pedido-cv">
              <div class="titulo-conteudo-detalhes"> CV </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.CurvaClienteTexto}} </div>
            </div>
          </div>
        </div>

        <div class="container-dados-pedido">
          <div class="dados-produto-titulo titulo-grupo-detalhes "> Dados do Pedido </div>
          
          <div class="grupo-dados-pedido">
            <div class="dados-pedido-status">
              <div class="titulo-conteudo-detalhes"> Status </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.StatusPedidoParcelaTexto}} </div>
            </div>

            <div class="dados-pedido-digitacao">
              <div class="titulo-conteudo-detalhes"> Digitação </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.DataDigitacaoFormatada}} </div>
            </div>

            <div class="dados-pedido-frete-cidade">
              <div class="titulo-conteudo-detalhes"> Frete / Cidade </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.IndicadorDeTipoFreteEnum}} - {{novoPedidoDetalhes.NomeCidade }} </div>
            </div>

            <div class="dados-pedido-transportadora">
              <div class="titulo-conteudo-detalhes"> Transportadora </div>
              <div class="label-conteudo"> MEGATRENDS LOGISTICA </div>
            </div>

            <div class="dados-pedido-papel-seda">
              <div class="titulo-conteudo-detalhes"> Papel Seda </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.EnviarPapelSedaDescricao}} </div>
            </div>

            <div class="dados-pedido-preco">
              <div class="titulo-conteudo-detalhes"> Preço </div>
              <div class="label-conteudo"> {{formataMonetario(novoPedidoDetalhes.ValorPrecoFinal)}} </div>
            </div>

            <div class="dados-pedido-preco">
              <div class="titulo-conteudo-detalhes"> Preço Total sem IPI </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.PrecoTotalSemIPIFormatado}} </div>
            </div>

            <div class="dados-pedido-qtd-total">
              <div class="titulo-conteudo-detalhes"> Qtd.Total </div>
              <div class="label-conteudo"> {{formataDecimal(novoPedidoDetalhes.NumeroQuantidadeTotalFormatado)}} </div>
            </div>

            <div class="dados-pedido-condicao-pagamento">
              <div class="titulo-conteudo-detalhes"> Condição Pagamento </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.CondicaoPagamento}} </div>
            </div>

            <div class="dados-pedido-comissao-representante">
              <div class="titulo-conteudo-detalhes"> Comissão Repr. </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.PorcentagemComissaoRepresentante}}% </div>
            </div>

            <div class="dados-pedido-comissao-venda">
              <div class="titulo-conteudo-detalhes"> Comissão Venda </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.PorcentagemComissaoVenda}}% </div>
            </div>

            <div class="dados-pedido-kanban">
              <div class="titulo-conteudo-detalhes"> Programação Kanban </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.ProgramacaoKanban == false ? 'Não' : 'Sim' }}    </div>
            </div>

            <div class="dados-pedido-codigo-acesso">
              <div class="titulo-conteudo-detalhes"> Código de Acesso </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.CodigoAcesso || 'Não Possui'}} </div>
            </div>

            <div class="dados-pedido-exportacao">
              <div class="titulo-conteudo-detalhes"> Exportação </div>
              <div class="label-conteudo"> {{ novoPedidoDetalhes.Exportacao == false ? 'Não' : 'Sim'}} </div>
            </div>
          </div>
        </div>

        <div class="container-carac-pedido"  v-if="detalhesDoPedidoFluxo.TipoFluxoOrcamento === 0 || detalhesDoPedidoFluxo.TipoFluxoOrcamento === 2">
          <div class="dados-produto-titulo titulo-grupo-detalhes "> Características do Pedido </div>
          
          <div class="grupo-caract-pedido">                 
            <div v-if="!(caracteristicasPedido.ImpressaoAmostra &&
              caracteristicasPedido.ImpressaoProvaDeCores &&
              caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar &&
              caracteristicasPedido.ImpressaoNumeroPantone &&
              caracteristicasPedido.ImpressaoNumeroDoProduto &&
              caracteristicasPedido.ImpressaoOutros)"
            >                                                  
              <div class="titulo-conteudo-detalhes"> Impressão </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoAmostra == true ? 'Amostra' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCores == true ? 'Prova De Cores' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar == true ? 'Prova De Cores a Confeccionar' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroPantone ? `Pantone Nº ${caracteristicasPedido.ImpressaoNumeroPantone}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroDoProduto ? `Produto: ${caracteristicasPedido.ImpressaoNumeroDoProduto}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoOutros ? `Outros: ${caracteristicasPedido.ImpressaoOutros}` : ''}} </div>
            </div>
                      
            <div v-if="!(caracteristicasPedido.VisualAmostra &&
              caracteristicasPedido.VisualArquivoDescricao &&
              caracteristicasPedido.VisualNumeroDoProduto &&
              caracteristicasPedido.DescricaoVisualOutros)"
            > 
              <div class="titulo-conteudo-detalhes"> Visual </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.VisualAmostra == true ? 'Amostra' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.VisualArquivoDescricao ? `Visual Arquivo: ${caracteristicasPedido.VisualArquivoDescricao}` : ''}} </div>
              <div class="label-conteudo"> {{caracteristicasPedido.VisualNumeroDoProduto ? `Produto: ${caracteristicasPedido.VisualNumeroDoProduto}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.DescricaoVisualOutros ? `Outros: ${caracteristicasPedido.DescricaoVisualOutros}` : ''}} </div>                  
            </div>

            <div v-if="!(caracteristicasPedido.FacaSistemaAmostra &&
              caracteristicasPedido.FacaSistemaRiscoDeFaca &&
              caracteristicasPedido.FacaSistemaPlanta &&
              caracteristicasPedido.FacaSistemaPrototipoDescricao &&
              caracteristicasPedido.CodigoFacaSistemaProduto &&
              caracteristicasPedido.FacaSistemaOutros)"
            >   

              <div class="titulo-conteudo-detalhes"> Faca Sistema </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaAmostra == true ? 'Amostra' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPlanta == true ? 'Planta' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaSistemaPrototipoDescricao}` : ''}} </div>
              <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaSistemaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaSistemaProduto}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaOutros ? `Outros: ${caracteristicasPedido.FacaSistemaOutros}` : ''}} </div>                     
            </div>

            <div v-if="!(caracteristicasPedido.FacaMedidaAmostra &&
              caracteristicasPedido.FacaMedidaRiscoDeFaca &&
              caracteristicasPedido.FacaMedidaPlanta &&
              caracteristicasPedido.FacaMedidaPrototipoDescricao &&
              caracteristicasPedido.CodigoFacaMedidaProduto &&
              caracteristicasPedido.FacaMedidaOutros)"
            >
              <div class="titulo-conteudo-detalhes"> Faca Medida </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaAmostra == true ? 'Amostra' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPlanta == true ? 'Planta' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaMedidaPrototipoDescricao}` : ''}} </div>
              <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaMedidaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaMedidaProduto}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaOutros ? `Outros: ${caracteristicasPedido.FacaMedidaOutros}` : ''}} </div>                            
            </div>
          </div>
        </div>

        <div class="container-dados-produto">
          <div class="dados-produto-titulo titulo-grupo-detalhes"> Produto </div>
                
          <div class="grupo-produtos">
            <div class="dados-produto-produto">
              <div class="titulo-conteudo-detalhes"> Produto </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.NomeProduto}} </div>
            </div>

            <div class="dados-produto-dataFaturamento">
              <div class="titulo-conteudo-detalhes"> Data do último faturamento </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.DataUltimoFaturamentoFormatada}} </div>
            </div>

            <div class="dados-produto-dataVenda">
              <div class="titulo-conteudo-detalhes"> Data da última venda </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.DataUltimaVendaFormatada}} </div>
            </div>

            <div class="dados-produto-porcentagem-ipi">
              <div class="titulo-conteudo-detalhes"> Porcentagem do IPI </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.Ipi || '0'}}% </div>
            </div>

            <div class="dados-produto-linha">
              <div class="titulo-conteudo-detalhes"> Produto está em Linha? </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.EmLinha || 'Não'}} </div>
            </div>

            <div class="dados-produto-selo">
              <div class="titulo-conteudo-detalhes"> Produto possui selo FSC? </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.Fsc || 'Não'}} </div>
            </div>
          </div>
        </div>

        <div class="container-observacoes">
          <div class="observacao-titulo titulo-grupo-detalhes"> Observações </div>
          
          <div class="grupo-observacoes">
            <div class="dados-pedido-observacaoVisual">
              <div class="titulo-conteudo-detalhes"> Observações da Impressão, Visual, Faca Sistema e Faca Medida </div>
              
              <div class="label-conteudo" v-for="(texto, index) in this.ObsArray" :key="index">
                <div class="label-conteudo"> {{ this.ObsArray ? texto : 'Sem Informações' }}  </div>
              </div>
            </div>

            <div class="dados-pedido-observacoes">
              <div class="titulo-conteudo-detalhes"> Observações </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.ObservacaoGeral || 'Sem Informações'}} </div>
            </div>

            <div class="dados-pedido-quantidade">
              <div class="titulo-conteudo-detalhes"> Quantidade </div>
              <div class="label-conteudo">Obs: De acordo c/ Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou a menos.</div>
            </div>
          </div>
        </div>
        
        <div class="container-componentes">
          <div class="titulo-grupo-detalhes"> Componentes </div>

          <div class="content-componentes" v-if="this.ComponentePedidoArray.length > 0">
            <div 
              class="box-componente" 
              v-for="(data, index) in ComponentePedidoArray"
              :key="data"
            >
              <div class="imagem-numero-nome-componente">
                <div class="imagem-grupo-componente">
                  <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                </div>
                
                <div class="numero-nome-componente">
                  <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                  <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                </div>
              </div> 

              <div class="grupo-componentes">
                <div class="componentes-medidas">
                  <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                  <div class="medidas label-conteudo">
                    {{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)  ? this.ColunaMedidas : data.descricaoMedidasTexto }}
                  </div>
                </div>

                <div class="componentes-cor-frente">
                  <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                  <div class="corFrente label-conteudo"
                  >
                  {{ data.descricaoCoresFrenteTexto }}
                  </div>
                </div>

                <div class="componentes-cor-verso">
                  <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                  <div class="corVerso label-conteudo"
                  >
                  {{ data.descricaoCoresVersoTexto }}
                  </div>
                </div>

                <div class="componentes-acabFrente">
                  <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                  <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                </div>

                <div class="componentes-acabVerso">
                  <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                  <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                </div>

                <div class="componentes-material">
                  <div class="material titulo-conteudo-detalhes"> Material </div>
                  <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                </div>

                <div class="componentes-onda">
                  <div class="onda titulo-conteudo-detalhes"> Onda </div>
                  <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                </div>

                <div class="componentes-capaExt">
                  <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                  <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                </div>

                <div class="componentes-gramaturaExt">
                  <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
                </div>

                <div class="componentes-capaInt">
                  <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                  <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                </div>

                <div class="componentes-gramaturaInt">
                  <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
                </div>

                <div class="componentes-papelOnda">
                  <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                  <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                </div>

                <div class="componentes-gramaturaPO">
                  <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                </div>

                <div class="componentes-codigo">
                  <div class="codigo-componente titulo-conteudo-detalhes"> Código </div>
                  <div class="label-conteudo">{{ data.codigoSistema }}</div>
                </div>

                <div class="componentes-descricao">
                  <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                  <div class="label-conteudo">{{ data.sistema }}</div>
                </div>

                <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                  <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                  <div class="label-conteudo">{{ data.produtoSistema }}</div>
                </div>

                <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                  <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                  <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                </div>

                <div class="componentes-embalagem-coletiva" 
                  v-if="  data.embalagemPalete == true || 
                  data.embalagemFilmeEncolhivel == true || 
                  data.embalagemCaixaColetiva == true || 
                  data.embalagemPapelEmbrulho == true || data.quantidadeOutros != 0"
                >
                  <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                  <div class="labels-embalagem-coletiva">
                    <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                    >
                      {{ texto }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="label-sem-componentes label-conteudo" v-else> Não possui componentes. </div>
        </div>      

        <div class="content-demaisCaract-critica">
          <div class="critica-titulo titulo-grupo-detalhes"> Críticas de Processo </div>

          <div class="grupo-critica">            
            <div class="critica-container">
              <div
                for="fechamento-maquina"
                class="criticaProcesso label-conteudo"
              >
                O produto terá fechamento por máquina por parte do cliente?
              </div>

              <label
                for="fechamento-maquina"
                :class="`label-checkbox critica-bool ${novoPedidoDetalhes.Critica3 ? 'botao-positivo' : 'botao-negativo'}`"
              >
                {{novoPedidoDetalhes.Critica3 ? 'SIM' : 'NÃO'}}
              </label>
            </div>
          </div>
        </div>  
      </div>
    </g-card>
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <PedidoEmAndamentoPDF 
        :tituloDetalhes="false" 
        v-on:termino="gerarPdf" 
        :pedidoSelecionado="PedidoId"
        @podeGerarPDF="podeGerarPdf = $event"
      ></PedidoEmAndamentoPDF>
    </div>
  </g-pdf>
</template>

<script>
import DetalhesPedidosCanceladosLiquidados from './DetalhesPedidosCanceladosLiquidados.js'
export default DetalhesPedidosCanceladosLiquidados
</script>

<style scoped>
.container-logo {
  padding: 30px 30px 10px 53px;
}

.critica-container {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-bottom: 2rem;
}

.criticaProcesso {
  margin-top: 1rem;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}

.critica-container .label-checkbox {
  margin-left: 0 !important;
}

.container-dados-pedido,
.container-carac-pedido, 
.container-dados-produto,
.container-observacoes,
.container-componentes,
.content-demaisCaract-critica {
  margin-top: 2rem;
}

.content-componentes {
  width: 100%;
  display: grid;
  gap: 1.5rem;
  margin-top: 1.2rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente .grupo-componentes {
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
}

.titulo-componentes {
    margin-bottom: 1.5rem;
}
.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
}

.box-componente .titulo-conteudo-detalhes {
  color: #3f3f3f;
  margin-top: 0.1rem;
  font-size: 0.9rem;
}

.box-componente .label-conteudo {
  font-size: 0.9rem;
}

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

@media(min-width:310px) {
  .grupo-dados-produto {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(7, auto);
    column-gap: 3%;
  }

  .grupo-dados-pedido {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(14, auto);
    column-gap: 3%;
  }

  .grupo-produtos {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(6, auto);
    column-gap: 3%;
  }

  .img-componente {
    height: 2.5rem;
    width: auto;
  }
}


@media(min-width:368px) {
  .grupo-dados-pedido {
    grid-template-columns: repeat(2, minmax(4em, 1fr));
  }
}

@media(min-width:450px) {
.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
}

@media(min-width:500px) {
.componentes-embalagem-coletiva { 
  grid-column: span 2; 
}
}

@media(min-width:600px) {
  .grupo-dados-produto {
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
  }

  .grupo-produtos {
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
  }

  .content-componentes {
    grid-template-columns: repeat(2, minmax(2rem, 1fr));
  }

  .componentes-produto, 
  .componentes-embalagem-coletiva { grid-column: span 2; } 
}


@media(min-width:801px) {
  .grupo-dados-produto {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
  }

  .grupo-dados-pedido {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
  }

  .grupo-produtos {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
  }
}


@media(min-width:1025px) {
  .content-componentes {
    column-gap: 4rem;
  }
  .imagem-numero-nome-componente {
    padding: 0.5rem 1rem;
  }
  .grupo-componentes {
    padding: 0 1rem;
  }
}


@media(min-width:1285px) {
  .grupo-dados-produto, .grupo-dados-pedido, .grupo-produtos {
    grid-template-columns: repeat(5, minmax(4em, 1fr));
  }

  .content-componentes {
    grid-template-columns: repeat(3, minmax(2rem, 1fr));
    column-gap: 1.5rem;
  }

  .imagem-numero-nome-componente, .grupo-componentes {
    padding: 0;
  }

  .box-componente .grupo-componentes {
    grid-template-columns: repeat(2, minmax(4rem, 1fr));
  }
  .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
  .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
  .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
  .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
  .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
  .componentes-material { grid-area: 4 / 1 / 5 / 2; }
  .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
  .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
  .componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
  .componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
  .componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
  .componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
  .componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
  .componentes-embalagem-coletiva { grid-column: span 2; }
}

@media(min-width:1500px) {
  .content-componentes {
    grid-template-columns: repeat(4, minmax(2rem, 1fr));
  }
}

@media (min-width: 1800px) {}

@media (min-width: 2000px) {}
</style>